import React from 'react';
import ChristmasLights from '../ChristmasLights';
import Snowfall from '../Snowfall';

const ChristmasDecorations = () => {
  return (
    <>
      <ChristmasLights />
      <Snowfall />
    </>
  );
};

export default ChristmasDecorations;
